export const getCopyEventTagViewStyles = () => ({
  copyEventTagView: {
    marginLeft: '26px',
    marginBottom: '12px',

    '& .event-tracking-dropdown': {
      marginBottom: 30,
      width: 250,
    },

    '& .event-tag-code': {
      background: '#fff4ce',
      border: 0,
    },

    '& .code-snippet': {
      minWidth: '560px',
      width: '720px',
      padding: '10px 12px',
      fontSize: '16px',
      lineHeight: '24px',
    },

    '& .event-tag-example': {
      marginLeft: 0,
      marginTop: '20px',

      '& .example-message': {
        marginLeft: '25px',
      },
    },
  },
});
